/**
 * Login Screen
 *
 * Tela de login do admin
 */
import React, { useState } from 'react'
import { Lock, Mail, Eye, EyeOff } from 'lucide-react'
import Button from '../atoms/Button'
import Input from '../atoms/Input'
import { useAdminAuth } from '../../core/admin.hooks'

export default function LoginScreen() {
	const { login, loading, error, clearError } = useAdminAuth()

	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [showPassword, setShowPassword] = useState(false)

	const handleSubmit = async (e) => {
		e.preventDefault()
		clearError()

		if (!email || !password) return

		await login(email, password)
	}

	return (
		<div className="min-h-screen h-screen bg-gradient-to-br from-base-100 via-base-300 to-primary-900 flex items-center justify-center p-4">
			<div className="w-full max-w-md">
				{/* Logo */}
				<div className="text-center mb-8">
					<div className="inline-flex items-center gap-2 mb-2">
						<span className="text-4xl">⚽</span>
						<span className="text-3xl font-bold text-white">FutJá</span>
					</div>
					<p className="text-text-body">Painel Administrativo</p>
				</div>

				{/* Card */}
				<div className="bg-base-300 rounded-2xl shadow-xl p-8">
					<h2 className="text-2xl font-bold text-text mb-2">
						Bem-vindo de volta
					</h2>
					<p className="text-text-body mb-6">
						Faça login para acessar o painel
					</p>

					{error && (
						<div className="mb-4 p-4 bg-danger/20 border border-danger/40 rounded-lg text-danger text-sm">
							{error}
						</div>
					)}

					<form onSubmit={handleSubmit} className="space-y-4">
						<Input
							label="Email"
							type="email"
							value={email}
							onChange={(e) => setEmail(e.target.value)}
							placeholder="seu@email.com"
							icon={Mail}
							required
						/>

						<div className="relative">
							<Input
								label="Senha"
								type={showPassword ? 'text' : 'password'}
								value={password}
								onChange={(e) => setPassword(e.target.value)}
								placeholder="••••••••"
								icon={Lock}
								required
							/>
							<button
								type="button"
								onClick={() => setShowPassword(!showPassword)}
								className="absolute right-3 top-9 text-text-body hover:text-text"
							>
								{showPassword ? (
									<EyeOff className="w-5 h-5" />
								) : (
									<Eye className="w-5 h-5" />
								)}
							</button>
						</div>

						<Button
							type="submit"
							className="w-full"
							loading={loading}
							disabled={!email || !password}
						>
							Entrar
						</Button>
					</form>
				</div>

				{/* Footer */}
				<p className="text-center mt-6 text-text-muted text-sm">
					© {new Date().getFullYear()} FutJá - Todos os direitos reservados
				</p>
			</div>
		</div>
	)
}
